/**
 * Shared API configuration.
 * WebSocket uses the same base URL as REST API (https -> wss).
 */
const PROD_API_BASE_URL = "https://api.akinda.io/api/v1";
const TEST_API_BASE_URL = "https://test-api.akinda.io/api/v1";

function resolveApiBaseUrl(): string {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  if (import.meta.env.DEV) {
    return TEST_API_BASE_URL;
  }
  if (typeof window !== "undefined" && window.location.hostname === "test.akinda.io") {
    return TEST_API_BASE_URL;
  }
  return PROD_API_BASE_URL;
}

/** Override with `VITE_API_URL` in `.env` (local) or CI build args. */
export const API_BASE_URL = resolveApiBaseUrl();

/** Apple Sign In redirect URI. Override via VITE_APPLE_REDIRECT_URI env var. */
export const APPLE_REDIRECT_URI =
  import.meta.env.VITE_APPLE_REDIRECT_URI ||
  (typeof window !== "undefined"
    ? /localhost|127\.0\.0\.1/.test(window.location.hostname)
      ? "https://akinda.io/auth/apple/callback"
      : `${window.location.origin}/auth/apple/callback`
    : "");

/** Deep link scheme for app callback (e.g. akinda). Used by WebView Google Sign-In redirect. */
export const APP_DEEP_LINK_SCHEME =
  import.meta.env.VITE_APP_DEEP_LINK_SCHEME ?? "akinda";

/** Stripe publishable key. Override via VITE_STRIPE_PUBLISHABLE_KEY env var. */
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ??
  "pk_live_51Nzw6wA8Bu9Sfv7SCekfiQ3IOkabLD2depWW2GAbojqNFkiW34hZxDHhptVcm9YKKSTBcPZyHceqPInGX3OA0WGP00fPR6nbZz";

export const getWebSocketUrl = (path: string, token: string): string => {
  const wsBase = API_BASE_URL.replace(/^https:\/\//, "wss://");
  return `${wsBase}${path}?token=${encodeURIComponent(token)}`;
};
